<template>
    <div
        class="base-radios"
        :class="{
            'base-radios--column': direction === 'column',
            'base-radios--row': direction === 'row'
        }"
    >
        <slot />
    </div>
</template>

<script setup>
defineProps({
    direction: {
        type: String,
        default: 'row'
    }
});
/*
use like this
<BaseRadios>
    <BaseRadio
        v-for="option in [{ label: 'Yes', value: true }, { label: 'No', value: false }]"
        :key="option.value"
        v-model="values.isMedicalProfessional"
        name="something"
        :value="option.value"
    >
        {{ option.label }}
    </BaseRadio>
</BaseRadios>
*/
</script>

<style lang="less" scoped>
.base-radios {
    display: flex;
    gap: 1rem;

    :deep(.dn-radio.base-radio) {
        margin: 0;
    }

    &--column {
        flex-direction: column;
    }

    &--row {
        flex-direction: row;
    }
}
</style>
